// Ephemeral "visitor is typing" state, keyed by sessionId. Driven by inbound
// `visitor:typing` bus events (see lib/bus-bridge.ts) and read by the
// Conversation route to show a transient indicator above the composer. Not
// persisted — purely live signal.

import { create } from 'zustand';
import type { SessionId } from '@prakash-software/shared';

interface TypingState {
  /** Sessions where the visitor is currently typing. */
  typing: Set<SessionId>;
  setTyping: (id: SessionId, isTyping: boolean) => void;
}

export const useTypingStore = create<TypingState>((set) => ({
  typing: new Set(),
  setTyping: (id, isTyping) =>
    set((s) => {
      if (s.typing.has(id) === isTyping) return s; // no-op — avoids re-render
      const next = new Set(s.typing);
      if (isTyping) next.add(id);
      else next.delete(id);
      return { typing: next };
    }),
}));
